import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SpinnerComponent {}
